<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Create Joint Profile</h3>
        <b-form>
            <b-row>
                <b-col cols="12">
                    <ul>
                        <li class="text-capitalize" v-for="(customer, index) in multiple_selection" :key="index">
                            {{ customer.name }} ({{ checkAppCode('vps') ? customer.masked_id : customer.customer_id }})
                        </li>
                    </ul>
                    <p class="text-center text-primary">{{ multiple_selection.length }} customer(s) selected.</p>
                </b-col>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <el-button :loading="is_loading" class="bg-primary text-white w-100" @click.prevent="createJointProfile">Confirm</el-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Button } from 'element-ui'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus'

export default {
    props:{
        show_create_joint_customer: Boolean,
        customer_sub_status_list: Array,
        multiple_selection: Array
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        show: {
            get() {
                return this.show_create_joint_customer;
            },
            set(newVal) {
                this.$emit('update:show_create_joint_customer', newVal);
            },
        },
    },
    data() {
        return {
            is_loading:false
        }
    },
    methods: {
        createJointProfile() {
            if(this.multiple_selection.length < 2){
                this.errorFunction(null, 'Please select a minimum of 2 customers.')
                return
            }
            let customer_ids = []
            this.multiple_selection.forEach((item) => {
                customer_ids.push(item.customer_id)
            })
            this.is_loading = true
            axios.post(services.customer + 'joint-profile', {customer_ids}, { headers: getHeader() })
            .then(res => {
                this.is_loading = false
                this.notifySuccess('<b>Joint Profile - <br>Successfully Created.')
                this.$router.push('customerProfileDetails/'+res.data.data.customer_id)
            })
            .catch(e => {
                this.is_loading = false
                this.errorFunction(e)
            })
        },
    }
}
</script>